// Test IDs for the account settings + auth-account UI.

export const ACCOUNT = {
  headerButton: 'account-header-button',
  headerAvatar: 'account-header-avatar',
};

export const AUTH_MODAL = {
  root: 'auth-modal',
  close: 'auth-modal-close',
  googleButton: 'auth-google-button',
  toggleMode: 'auth-toggle-mode',
  error: 'auth-error',
};

export const SETTINGS = {
  page: 'settings-page',
  gate: 'settings-gate',
  gateSignIn: 'settings-gate-signin',
  logoutButton: 'settings-logout-button',
  // profile
  profileName: 'settings-profile-name',
  profileEmail: 'settings-profile-email',
  profileSave: 'settings-profile-save',
  avatarInput: 'settings-avatar-input',
  avatarUpload: 'settings-avatar-upload',
  // security
  currentPassword: 'settings-current-password',
  newPassword: 'settings-new-password',
  passwordSave: 'settings-password-save',
  deleteAccount: 'settings-delete-account',
  deleteConfirm: 'settings-delete-confirm',
  // notifications
  notifEmail: 'settings-notif-email',
  notifInapp: 'settings-notif-inapp',
  // preferences
  prefTopSize: 'settings-pref-top-size',
  prefBottomSize: 'settings-pref-bottom-size',
  prefCategory: 'settings-pref-category',
  prefMarketing: 'settings-pref-marketing',
  prefSave: 'settings-pref-save',
  wishlist: 'settings-wishlist',
};
